import { render } from "./MergeTheme.vue?vue&type=template&id=1a5d09fc&scoped=true&ts=true"
import script from "./MergeTheme.vue?vue&type=script&lang=ts"
export * from "./MergeTheme.vue?vue&type=script&lang=ts"

import "./MergeTheme.vue?vue&type=style&index=0&id=1a5d09fc&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5d09fc"]])

export default __exports__